module.exports = __webpack_public_path__ + "feedbackmodule/img/logo_ITTM.b3e59308.png";